<template>
  <div id="app">
    <v-app id="inspire">
      <div>
        <v-app-bar
            color="deep-purple accent-4"
            dense
            dark
            fixed
        >
<!--            shrink-on-scroll-->
<!--            fade-img-on-scroll-->
          <v-app-bar-nav-icon></v-app-bar-nav-icon>

          <v-toolbar-title>Page title</v-toolbar-title>

          <v-spacer></v-spacer>

          <v-btn icon>
            <v-icon>mdi-heart</v-icon>
          </v-btn>

          <v-btn icon>
            <v-icon>mdi-magnify</v-icon>
          </v-btn>

          <v-menu
              left
              bottom
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                  icon
                  v-bind="attrs"
                  v-on="on"
              >
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>

            <v-list>
              <v-list-item
                  v-for="n in 5"
                  :key="n"
                  @click="() => {}"
              >
                <v-list-item-title>Option {{ n }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-app-bar>



        <v-list two-line>
          <v-list-item-group
              v-model="selected"
              active-class="pink--text"
          >
<!--              multiple-->
            <template v-for="(item, index) in items">
              <v-list-item :key="item.title">
<!--                <template v-slot:default="{ active }">-->
                <template v-slot:default="{ }">
                  <v-list-item-action>
<!--                    <v-checkbox :input-value="active"></v-checkbox>-->
                    <v-checkbox ></v-checkbox>
<!--                    <v-icon-->
<!--                        v-if="!active"-->
<!--                        color="grey lighten-1"-->
<!--                    >-->
<!--                      mdi-checkbox-blank-outline-->
<!--                    </v-icon>-->

<!--                    <v-icon-->
<!--                        v-else-->
<!--                        color="yellow darken-3"-->
<!--                    >-->
<!--                      mdi-check-->
<!--                    </v-icon>-->


                  </v-list-item-action>

                  <v-list-item-content>
                    <v-list-item-title v-text="item.title"></v-list-item-title>

                    <v-list-item-subtitle
                        class="text--primary"
                        v-text="item.headline"
                    ></v-list-item-subtitle>

                    <v-list-item-subtitle v-text="item.subtitle"></v-list-item-subtitle>
                  </v-list-item-content>

                  <v-list-item-action>
                    <v-list-item-action-text v-text="item.action"></v-list-item-action-text>

<!--                    <v-icon-->
<!--                        v-if="!active"-->
<!--                        color="grey lighten-1"-->
<!--                    >-->
<!--                      mdi-dots-vertical-->
<!--                    </v-icon>-->

<!--                    <v-icon-->
<!--                        v-else-->
<!--                        color="yellow darken-3"-->
<!--                    >-->
<!--                      mdi-dots-vertical-->
<!--                    </v-icon>-->

                    <v-btn icon>
                      <v-icon color="grey lighten-1">mdi-dots-vertical</v-icon>
                    </v-btn>

                  </v-list-item-action>
                </template>
              </v-list-item>

              <v-divider
                  v-if="index < items.length - 1"
                  :key="index"
              ></v-divider>
            </template>
          </v-list-item-group>
        </v-list>
      </div>
    </v-app>
  </div>
</template>

<script>
/**

 **/


export default {
  //name: "MobileUI",
  // props: [""],
  data: function () {
    return {
      selected: [2],
      items: [
        {
          action: '2020-06-01',
          headline: 'Brunch this weekend?',
          subtitle: `I'll be in your neighborhood doing errands this weekend. Do you want to hang out?`,
          title: 'Ali Connors',
        },
        {
          action: '2 hr',
          headline: 'Summer BBQ',
          subtitle: `Wish I could come, but I'm out of town this weekend.`,
          title: 'me, Scrott, Jennifer',
        },
        {
          action: '6 hr',
          headline: 'Oui oui',
          subtitle: 'Do you have Paris recommendations? Have you ever been?',
          title: 'Sandra Adams',
        },
        {
          action: '12 hr',
          headline: 'Birthday gift',
          subtitle: 'Have any ideas about what we should get Heidi for her birthday?',
          title: 'Trevor Hansen',
        },
        {
          action: '18hr',
          headline: 'Recipe to try',
          subtitle: 'We should eat this: Grate, Squash, Corn, and tomatillo Tacos.',
          title: 'Britta Holt',
        },
      ],
    };
  },
  computed: {
    formTitle () {
      return ""
      // return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
    }
  },
  methods: {
    async loadData() {
      // let data=await apiUtil.api_SupplierTODO("12138114-01")

      // this.data=data
    },
    editChildItem (item) {  // eslint-disable-line
      // this.editedIndex = this.items.active.children.indexOf(item)
      // this.editedItem = Object.assign({}, item)
      // this.dialog = true
    },
    deleteChildItem (item) {  // eslint-disable-line
      // const index = this.items.active.children.indexOf(item)
      // confirm('Are you sure you want to delete this item?') && this.items.splice(index, 1)
    },
  },
  mounted() {
    //this.loadData()
  },
}
</script>

<style scoped>

</style>